/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const speedometer = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.004 5.178C11.727 3.854 9.948 3.015 8 3c-1.925.015-3.703.854-4.986 2.178M8 3v1.244m-6.997 5.6H2.4m-1.397 0c.056-1.79.82-3.437 2.01-4.666m-2.01 4.666C.99 10.26 1 10.841 1 11.256c0 .687.557 1.244 1.245 1.244h3.888m-3.12-7.322.943.933m9.048-.933-.96.933m.96-.933c1.185 1.228 1.938 2.874 1.993 4.666m0 0H13.6m1.397 0c.012.415.003.997.003 1.412 0 .687-.557 1.244-1.245 1.244H9.867m0 0v-1.244c0-.9-.635-1.575-1.5-1.725A2.151 2.151 0 0 0 8 9.5c-1.017 0-1.867.739-1.867 1.756V12.5m0 0h3.734m-1.5-2.969L9 7"
    />
  </svg>
)
export default speedometer
